<template>
  <f7-page id="training-session-id"  v-if="training_session">
    <f7-navbar :title="training_session.start_date_day" back-link="">
      <f7-nav-right>
        <f7-link v-show="has_activities && !editable" sortable-toggle=".sortable" @click="toggleEditable">Edit</f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-toolbar tabbar labels position="top" class="training-edit-toolbar" v-if="editable && has_activities">
      <f7-link class="tab-link" :href="false"
        :icon-color="selectedActivities.length >= 2 ? 'brand-primary' : ''"
        @click.prevent="linkSelectedActivities"
        text="Super Set"
        icon-ios="f7:link"        icon-md="f7:link"></f7-link>
      <f7-link class="tab-link" :href="false"
        :icon-color="selected_superset ? 'brand-primary' : ''"
        @click.prevent="unLinkSelectedActivities"
        text="Unlink"
        icon-ios="f7:link"        icon-md="f7:link"></f7-link>
      <f7-link  class="tab-link" :href="false"
                @click.prevent="deleteSelectedActivities"
               :icon-color="selectedActivities.length >= 1 ? 'brand-primary' : ''" tab-link="" text="Verwijder"
               icon-ios="f7:trash"               icon-md="f7:trash"></f7-link>
      <!--      <f7-link tab-link="" text="Copy"-->
      <!--               icon-ios="f7:rectangle_on_rectangle"-->
      <!--               icon-md="f7:rectangle_on_rectangle"></f7-link>-->
      <f7-link class="tab-link" :href="false"
               @click.prevent="openActivitySelector"
               icon-color="brand-primary"
               text="Nieuw"
               icon-ios="f7:plus"               icon-md="f7:plus"></f7-link>
      <f7-link class="tab-link" :href="false"
               @click="toggleEditable"
               sortable-toggle=".sortable"
               icon-color="brand-primary"
               text="Klaar"
               icon-ios="f7:checkmark_alt"               icon-md="f7:checkmark_alt"></f7-link>

      <!-- Disabled for now. Turned out the users thought this would stop the Edit state, so we're doing that. -->
      <!--      <f7-link @click="markSelectedActivitiesAsFinished"-->
      <!--               :icon-color="selectedActivities.length >= 1 ? 'brand-primary' : ''"-->
      <!--               tab-link="" text="Klaar"-->
      <!--               icon-ios="f7:checkmark_alt"-->
      <!--               icon-md="f7:checkmark_alt"></f7-link>-->
    </f7-toolbar>

    <f7-block-title id="training-name">
      <h4 v-if="has_activities" style="margin-bottom:10px;" class="d-inline">
        {{ training_session.name }}
      </h4>
      <h4 v-else style="margin:0;" class="d-inline">
        Voeg je eerste oefening toe!
      </h4>
      <f7-icon f7="exclamationmark_circle_fill" class="float-right"
               v-if="has_activities"
        @click="showFeedbackSheet = true"
      ></f7-icon>

    </f7-block-title>

    <f7-card v-if="!has_activities" class="card-raised" style="border-radius: 10px;">
      <f7-card-header
        class="no-border"
        valign="bottom"
        style="padding:0; width: 100%;  overflow:hidden; border-radius: 10px; background-color:transparent;"
      >
        <img src="/static/gifs/ready-for-activity-5.gif" style="padding:0; position:relative; border-radius:10px;">
      </f7-card-header>
    </f7-card>

    <f7-list v-if="has_activities" sortable @sortable:sort="onSort" class="list-strong list-outline list-dividers">
      <template v-for="(activity_id, index) in activity_order">
        <super-set-list-item :key="'superset-item' + activity_id" v-if="Array.isArray(activity_id)"
                             :activity_ids="activity_id"
                             :training_session="training_session"
                             :editable="editable"
                             :clear_checkbox="clear_superset_checkboxes"
                             @change="selectedActivity(activity_id, index)"
                             :is_last="(activity_order.length === (index + 1))"
                            :is_first="index === 0"
                             :f7router="f7router"
        >
        </super-set-list-item>
        <activity-list-item v-else
                            :f7router="f7router"
                            :key="'activity-item' + activity_id"
                            :activity_id="activity_id"
                            :training_session="training_session"
                            :editable="editable"
                            :sortable="editable"
                            :clear_checkbox="clear_activity_checkboxes"
                            @change="selectedActivity(activity_id, index)"
                            :is_last="(activity_order.length === (index + 1))"
                            :is_first="index === 0"
        >
        </activity-list-item>
      </template>
    </f7-list>

    <f7-block>
      <f7-row>
        <f7-col>
          <f7-button fill large @click="activitySelector = true">Oefening Toevoegen</f7-button>
        </f7-col>
      </f7-row>
    </f7-block>

    <f7-sheet :opened="activitySelector" class="high darker" @sheet:closed="activitySelector = false"
              swipe-to-close
              backdrop
    >


      <f7-navbar title="Activiteiten">
        <f7-nav-right>
          <f7-link sheet-close>Sluiten</f7-link>
        </f7-nav-right>
        <f7-subnavbar :inner="false">
          <!-- Does not seem to work in a modal for now. No time left to investigate -->
          <f7-searchbar
            search-container=".search-list"
            search-in=".item-title"
            :disable-button="true"

            :init="true"
            @click:clear="searchQuery = ''"
            v-model:value="searchQuery"
          ></f7-searchbar>
        </f7-subnavbar>
      </f7-navbar>
      <f7-page-content v-if="activitySelector">
        <f7-list v-if="filteredExercises.length === 0" class="list-strong list-outline list-dividers">
          <f7-list-item title="Geen oefening(en) gevonden"></f7-list-item>
        </f7-list>
        <f7-list class="search-list searchbar-found list-strong list-outline list-dividers">
          <f7-list-item @click="addNewActivity(exercise)"
                        :key="exercise.id"
                        :title="exercise.name"
                        v-for="exercise in filteredExercises"
                        v-if="exercise !== null"
          >

          </f7-list-item>
        </f7-list>
      </f7-page-content>
    </f7-sheet>
    <feedback-sheet-modal
        title="Melding"
        :show="showFeedbackSheet"
        @closed="showFeedbackSheet = false"
    ></feedback-sheet-modal>
  </f7-page>
</template>

<script>
  import ActivityListItem from "../../../components/training_sessions/ActivityListItem.vue";
  import Utility from "../../../js/utility";
  import SuperSetListItem from "../../../components/training_sessions/SuperSetListItem.vue";
  import { f7, f7ready } from 'framework7-vue';
  import FeedbackSheetModal from "../../../components/general/FeedbackSheetModal.vue";
  import utility from "../../../js/utility";

  export default {
    components: {
      FeedbackSheetModal,
      SuperSetListItem,
      ActivityListItem,
    },

    props: {
      f7route: Object,
      f7router: Object,
    },

    mixins: [],

    data: function () {
      return {
        title: 'Title',
        editable: false,
        activitySelector: false,
        selectedActivities: [],
        showFeedbackSheet: false,

        // Increase this to clear the checkboxes of the activities
        clear_activity_checkboxes: 0,
        clear_superset_checkboxes: 0,
        selected_superset: false,
        selected_activity: false,

        searchQuery: '',
      };
    },

    computed: {
      user_id() {
        return this.$store.state.current_user.data.id;
      },
      training_session_id() {
        return parseInt(this.f7route.params.training_session_id);
      },
      training_session() {
        return this.$store.getters['training_sessions/find'](this.training_session_id);
      },
      exercises() {
        return this.$store.getters['exercises/all'].filter(exercise => {
          return exercise.active;
        });
      },
      filteredExercises() {
        let vm = this;
        return this.exercises.filter(exercise => {
          return utility.matches_filter_query(exercise, vm.searchQuery, ['name']);
        })
      },
      activities() {
        return this.$store.getters['activities/data'].filter(activity => {
          return activity.training_session_id === this.training_session_id;
        });
      },
      training_session_activity_order() {
        return this.training_session.activity_order;
      },
      activity_order() {
        if (this.training_session_activity_order.length > 0) {
          return this.training_session_activity_order;
        }
        return this.activities.map(activity => {
          return activity.id
        });
      },
      has_activities() {
        return this.activity_order.length > 0;
      }
    },

    created() {
      // console.log('f7router', this.f7router);
      // console.log('f7route', this.f7route);
    },

    mounted() {
      //
    },

    methods: {
      onFocusSearch(string) {
        this.$refs.searchBar.enable();
      },
      onSort(sort) {

        let newActivitySortOrder = Utility.sort(sort.from, sort.to, Utility.deep_clone(this.activity_order));
        // Sort data
        // Save
        this.$store.dispatch('training_sessions/update', {
          user_id: this.user_id,
          training_session_id: this.training_session_id,
          activity_order: newActivitySortOrder,
        });
      },
      linkSelectedActivities() {
        // We can't link supersets!
        if (this.selected_superset) {
          return false;
        }

        // We can't link 0 or 1 activity
        if (this.selectedActivities.length < 2) {
          this.$store.dispatch('notifications/addWarningNotification', {message: 'Selecteer 2 of meer oefeningen om een superset te maken.'});
          return false;
        }

        // When the user links the selected activities we first:
        // Find the ID of the first Activity in the ordered_activities array
        let linkedActivitiesSortOrderIndex = -1;
        this.activity_order.every((activityId, index) => {
          activityId = parseInt(activityId);
          if (this.selectedActivities.includes(activityId)) {
            linkedActivitiesSortOrderIndex = index;
            // Found it, let's break
            return false;
          }
          // Continue
          return true;
        });

        let newSortOrderArray = Utility.clone(this.activity_order);
        // Insert the new array with linked activity IDs at the index of the first Activity ID
        // Overwrite the first selected activity with the Array of activities (superset)
        // And turn it into strings so it matches the sort_order syntax
        newSortOrderArray[linkedActivitiesSortOrderIndex] = this.selectedActivities;

        // Remove all the selectedActivity IDs from the this.activity_order array
        newSortOrderArray = newSortOrderArray.filter((activityId, index) => {
          if (Array.isArray(activityId)) {
            return true;
          }
          // return true;
          return !this.selectedActivities.includes(parseInt(activityId));
        });

        // Save
        this.$store.dispatch('training_sessions/update', {
          user_id: this.user_id,
          training_session_id: this.training_session_id,
          activity_order: newSortOrderArray,
        }).then(() => {
          // And clear the selection
          this.clearSelection();
        });

      },
      unLinkSelectedActivities() {
        // When we have selected activities, we can't unlink
        if (this.selected_activity) {
          return false;
        }

        let newSortOrderArray = this.activity_order; // Utility.deep_clone(this.activity_order);

        // Here we have one or more arrays who'se IDs we need to get out of their own, and insert
        // at the right position in the current activity_order array.
        this.selectedActivities.forEach(activityIdsArray => {

          let activityOrderIndex = Utility.find_index_of_matching_value(newSortOrderArray, activityIdsArray);

          // Now we have the ID / place where we need to insert the activities that will be
          // unlinked in in the sort order
          // First we remove the value:
          newSortOrderArray.splice(activityOrderIndex, 1);

          // Now we loop through the IDs backwards, and insert them at the right point.
          // It's backwards because then the first will end up first as well
          activityIdsArray.reverse().forEach(activityId => {
            newSortOrderArray.splice(activityOrderIndex, 0, activityId);
          });
        });

        // Save
        this.$store.dispatch('training_sessions/update', {
          user_id: this.user_id,
          training_session_id: this.training_session_id,
          activity_order: newSortOrderArray,
        }).then(() => {
          // And clear the selection
          this.clearSelection();
        });
      },
      toggleEditable() {

        this.editable = !this.editable;
      },
      addNewActivity(exercise) {
        this.$store.commit('app/show_loader');
        this.$store.dispatch('activities/store', {
          user_id: this.user_id,
          training_session_id: this.training_session_id,
          exercise_id: exercise.id,
        }).then(response => {
          this.$store.commit('app/hide_loader');
          this.activitySelector = false;
        });
      },
      selectedActivity(activityId, activityOrderIndex) {

        // We want to remove all regular IDs and only leave the supersets if we select a superset
        if (Array.isArray(activityId)) {
          this.selected_superset = true;
          this.selected_activity = false;
          this.clear_activity_checkboxes++;
          // And remove all non-arrays from the index
          this.selectedActivities = this.selectedActivities.filter(activityId => {
            return Array.isArray(activityId);
          })
        }
        // And vice versa remove all the arrays if we select a regular activity
        else {
          this.selected_superset = false;
          this.selected_activity = true;
          activityId = parseInt(activityId);
          this.clear_superset_checkboxes++;
          // And remove all arrays from the index
          this.selectedActivities = this.selectedActivities.filter(activityId => {
            return !Array.isArray(activityId);
          })
        }

        // Remove from array when it's in there
        let activityIndex = Utility.find_index_of_matching_value(this.selectedActivities, activityId);
        if (activityIndex > -1) {
          this.selectedActivities.splice(activityIndex, 1);
          return false;
        }
        // Add to array when it's not
        this.selectedActivities.push(activityId);
        return true;
      },
      deleteSelectedActivities() {
        let activityIds = Utility.deep_clone(this.selectedActivities).flat();

        this.$store.dispatch('activities/destroy', {
          user_id: this.user_id,
          training_session_id: this.training_session.id,
          activity_ids: activityIds,
        });

        // And clear the selection
        this.clearSelection();
      },
      openActivitySelector() {
        this.clearSelection();
        this.activitySelector = true;
      },
      clearSelection() {
        this.selectedActivities = [];
        this.clear_superset_checkboxes++;
        this.clear_activity_checkboxes++;
      }
    },

    watch: {
      // // Deze moet om de reactivity the triggeren
      activities: {
        deep: true,
        handler(value) {
          //console.log('activities watcher', value)
        }
      },
      // Deze moet om de reactivity the triggeren
      activity_order: {
        deep: true,
        handler(value) {
          //console.log('activity_order watcher', value)
        }
      },
      // // Deze moet om de reactivity the triggeren
      training_session_activity_order: {
        deep: true,
        handler(value) {
          //console.log('training_session_activity_order watcher', value)
        }
      },
      editable(value) {
        if (!this.editable) {
          // Reset the activities when disabling the editable mode
          this.selectedActivities = [];
        }
      },
      selectedActivities: {
        deep: true,
        handler(selectedActivities) {
          //console.log('selectedActivities watcher', selectedActivities);
          if (selectedActivities.length === 0) {
            this.selected_superset = false;
            this.selected_activity = false;
          }
        }
      },
    }
  };
</script>
<style lang="scss">
  #training-session-id {
    .navbar .title {
      padding-left: 4px;
    }

    #training-name {
      margin-top: 0;

      h3 {
        margin-top: 0;
      }
    }
  }
</style>
